import React from "react";
import { identity } from "lodash";
import { PanelPropertiesCard } from "@sonder/ui/source/styled/components/PanelPropertiesCard";
import { TaskData } from "core/queries/GetTask";
import { formatDate } from "tasks/helpers";

// Exports
export const INTERNAL_HOLD_INFO = {
  heading: "Internal Hold",
  options: [
    {
      label: "Type",
      path: "internalHold.holdType",
      transform: identity,
    },
    {
      label: "Start time",
      path: "internalHold.startAt",
      transform: formatDate,
    },
    {
      label: "End time",
      path: "internalHold.endAt",
      transform: formatDate,
    },
  ],
};

export const InternalHoldCard = ({ task }: { task: TaskData }) => (
  <PanelPropertiesCard
    data={task}
    heading={INTERNAL_HOLD_INFO.heading}
    options={INTERNAL_HOLD_INFO.options}
  />
);
